import { AppLayout } from '@/components/layout/AppLayout'
import { AtlasPage } from '@/components/ui/AtlasPage'
import { PageTitle } from '@/components/ui/PageTitle'
import { Separator } from '@/components/ui/Separator'
import { PageNumber } from '@/components/ui/PageNumber'
import { Button } from '@/components/ui/Button'
import { useForm, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types/inertia'

function PasswordsEdit() {
  const { token } = usePage<SharedProps & { token?: string }>().props

  const { data, setData, put, processing } = useForm({
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/passwords/${token || ''}`)
  }

  return (
    <AtlasPage narrow>
      <PageTitle title="Nowe hasło" subtitle="Ustaw nowe hasło do konta" />
      <Separator />

      <form onSubmit={handleSubmit} className="space-y-md">
        <div>
          <label className="block font-label text-xs text-frame uppercase tracking-wide mb-xs">
            Nowe hasło
          </label>
          <input
            type="password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            className="form-input"
            required
            autoFocus
            autoComplete="new-password"
          />
        </div>

        <div>
          <label className="block font-label text-xs text-frame uppercase tracking-wide mb-xs">
            Powtórz hasło
          </label>
          <input
            type="password"
            value={data.password_confirmation}
            onChange={(e) => setData('password_confirmation', e.target.value)}
            className="form-input"
            required
            autoComplete="new-password"
          />
        </div>

        <Separator />

        <div className="flex justify-center">
          <Button type="submit" disabled={processing}>
            Ustaw hasło
          </Button>
        </div>
      </form>

      <PageNumber number={22} />
    </AtlasPage>
  )
}

PasswordsEdit.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
export default PasswordsEdit
